import { Typography } from '@ori-ui/mui';
import { Shade, ShadeSize } from '@ori/presentation-components';
import { useMemo, type FC } from 'react';

import { SEARCH_SHADE } from './constants';
import { Root } from './styles';
import { type ShadesProps } from './types';

export const Shades: FC<ShadesProps> = ({ shades, maxVisible }) => {
  const shadesToRender = useMemo(
    () =>
      shades.slice(0, maxVisible).map((shade) => (
        <Shade
          key={shade.productCode}
          shade={shade}
          size={ShadeSize.Small}
          testId={SEARCH_SHADE}
        />
      )),
    [shades, maxVisible],
  );

  if (shades.length < 2) {
    return null;
  }

  return (
    <Root>
      {shadesToRender}
      {shades.length > maxVisible ? (
        <Typography
          color="textPrimary"
          variant="overline"
          fontWeight="bold"
          lineHeight="normal"
        >
          +{shades.length - maxVisible}
        </Typography>
      ) : null}
    </Root>
  );
};
